import { render, staticRenderFns } from "./new_TextScroll.vue?vue&type=template&id=2cdc257d&scoped=true"
import script from "./new_TextScroll.vue?vue&type=script&lang=js"
export * from "./new_TextScroll.vue?vue&type=script&lang=js"
import style0 from "./new_TextScroll.vue?vue&type=style&index=0&id=2cdc257d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc257d",
  null
  
)

export default component.exports